import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { SeoService } from './services/seo/seo.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  public router: string = '';
  loading: boolean = false;
  title = 'BIM';
  googleLatitude: any;
  googleLongitude: any;
  urlRouter:any;
  
  constructor(location: Location, router: Router, private seoService: SeoService) {
    // const serverURL = environment.API_URL;
    // const serverImgURL = environment.IMG_URL;

    // localStorage.setItem('ServerUrl', serverURL);
    // localStorage.setItem('ServerImgUrl', serverImgURL);

    //this.userService.user.subscribe(x => this.user = x); 
    router.events.subscribe((val) => {
      if (location.path() != '') {
        this.urlRouter = location.path();
        if(this.urlRouter.split('/')[1] == 'business'){
          this.router = '/business';
        } else if(this.urlRouter.split('/')[1] == 'search'){
          this.router = '/search';
        } else {
          this.router = location.path();
        }
      } else {
        this.router = 'register'
      }
    });

    router.events.pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.updateSeo(event.urlAfterRedirects));
  }

  private updateSeo(url: string): void {
    const path = url.split('?')[0].replace(/\/$/, '') || '/';
    const pages: Record<string, { title: string; description: string; robots?: string }> = {
      '/': {
        title: 'Maharashtra Business Directory and Product Listings',
        description: 'Find businesses, products and services in Maharashtra, or create a business profile and reach more customers.'
      },
      '/home': {
        title: 'Maharashtra Business Directory and Product Listings',
        description: 'Find businesses, products and services in Maharashtra, or create a business profile and reach more customers.'
      },
      '/business': {
        title: 'Business Directory in Maharashtra',
        description: 'Browse Maharashtra business listings by category, location and industry.'
      },
      '/products': {
        title: 'Products for Sale in Maharashtra',
        description: 'Discover products from Maharashtra businesses and sellers.'
      },
      '/about': { title: 'About Business in Maharashtra', description: 'Learn how Business in Maharashtra helps local businesses build their online presence.' },
      '/contact': { title: 'Contact Business in Maharashtra', description: 'Contact the Business in Maharashtra team for help with listings, products and advertising.' },
      '/site-map': { title: 'Site Map', description: 'Explore the public pages and business categories available on Business in Maharashtra.' },
      '/privacy-policy': { title: 'Privacy Policy', description: 'Read the Business in Maharashtra privacy policy.' },
      '/terms-and-conditions': { title: 'Terms and Conditions', description: 'Read the Business in Maharashtra terms and conditions.' },
      '/return-policy': { title: 'Return Policy', description: 'Read the Business in Maharashtra return policy.' },
      '/refund-and-cancellation': { title: 'Refund and Cancellation Policy', description: 'Read the Business in Maharashtra refund and cancellation policy.' },
      '/shipping-policy': { title: 'Shipping and Delivery Policy', description: 'Read the Business in Maharashtra shipping and delivery policy.' },
      '/login': { title: 'Login', description: 'Log in to manage your Business in Maharashtra profile.', robots: 'noindex, follow' },
      '/register': { title: 'Create a Business Profile', description: 'Create your Business in Maharashtra profile.', robots: 'noindex, follow' },
      '/search': { title: 'Search Business Listings', description: 'Search Maharashtra businesses, products and services.', robots: 'noindex, follow' }
    };
    const config = pages[path] || (path.startsWith('/search/')
      ? pages['/search']
      : path.startsWith('/business-details/')
        ? { title: 'Business Profile', description: 'View business information, products and services in Maharashtra.' }
        : path.startsWith('/product-details/')
          ? { title: 'Product Details', description: 'View product details from a Maharashtra business.' }
          : { title: 'Business in Maharashtra', description: 'Find businesses, products and services in Maharashtra on Business in Maharashtra.', robots: 'noindex, follow' });
    this.seoService.update(config);
  }

  ngOnInit() {}
 
  // Close map model
  closeMapModel() {
    const modelDiv = document.getElementById('myMapModel');
    const modelBackdropDiv = document.getElementById('modalBackdrop');
    if (modelDiv != null && modelBackdropDiv != null) {
      modelDiv.style.display = 'none';
      modelDiv.classList.remove("show");
      modelBackdropDiv.classList.remove("show");
    }
  }

  // Close enquiry model
  closeEnquiryModel() {
    const modelDiv = document.getElementById('myEnquiryModel');
    const modelBackdropDiv = document.getElementById('modalBackdrop');
    if (modelDiv != null && modelBackdropDiv != null) {
      modelDiv.style.display = 'none';
      modelDiv.classList.remove("show");
      modelBackdropDiv.classList.remove("show");
    }
  }

}